import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Plays from './playFeed/Plays';
import { PlayFeedWrapper, PlayFeedList, InningHeader } from './PlayFeed.style';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import { Overlay } from '@gameday/components/';
import AtBatDataContainer from '@gameday/components/AtBat/containers/AtBatDataContainer';
import { ModalTypes } from '../AtBat/atbat.style';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import useTracking from '@gameday/utils/hooks/useTracking';

export const makeInningHeader = (preText, inning, isLoading, length) => {
    if (length > 0) {
        if (isLoading) {
            return <Skeleton height='24px' width='100px' margin='24px' />;
        }
        return <InningHeader>{preText} {inning}</InningHeader>;
    }
    return null;
};

const PlayFeed = ({
    playsByInning = [],
    teams,
    width = '100%',
    height = '100%',
    reverseChron = true
}) => {
    const [atBatContent, setAtBatContent] = useState(null);
    const [isOpen, setOpen] = useState(false);
    const onClose = () => setOpen(false);
    const isSingleCol = useMedia({ maxWidth: GDBREAKPOINTS.SM });
    const Tracking = useTracking();

    const openAtBatOverlay = (e) => {
        const selectedIndex = e?.currentTarget?.dataset?.atbatindex;
        if (typeof selectedIndex !== 'undefined') {
            const playIndex = selectedIndex * 1;
            setAtBatContent(<AtBatDataContainer playIndex={playIndex} />);
            setOpen(true);
            Tracking.track.track_atbat_detail_pageload({ playIndex });
            Tracking.track.track_atbat_overlay_launch({
                playIndex,
                componentName: ['Play Detail', 'Pitch by Pitch'],
                text: e?.currentTarget?.innerText || ''
            });
        }
    };

    const playsProps = {
        teams,
        offset: true,
        reverseChron,
        openAtBatOverlay
    };

    const orderedPlaysByInning = reverseChron ? [...playsByInning].reverse() : playsByInning;

    return (
        <PlayFeedWrapper
            width={ width }
            height={ height }
        >

            <PlayFeedList>
                {
                    orderedPlaysByInning.map((playsObj, i) => (
                        <React.Fragment key={`inning-${i}`}>
                            <Plays playArr={ reverseChron ? playsObj.bottom : playsObj.top } {...playsProps} />
                            <Plays playArr={ reverseChron ? playsObj.top : playsObj.bottom } {...playsProps} />
                        </React.Fragment>
                    ))
                }
            </PlayFeedList>
            {<Overlay
                isCentered={true}
                isOpen={isOpen}
                onClose={onClose}
                type={isSingleCol ? ModalTypes.VERTICAL : ''}
            >

                {atBatContent}
            </Overlay>}
        </PlayFeedWrapper>
    );
};

PlayFeed.propTypes = {
    playsByInning: PropTypes.arrayOf(PropTypes.object),
    teams: PropTypes.object,
    width: PropTypes.string,
    height: PropTypes.string,
    reverseChron: PropTypes.bool
};

export default PlayFeed;
